// Parse Cloudinary URL from environment variable
// Format: cloudinary://API_KEY:API_SECRET@CLOUD_NAME
const parseCloudinaryUrl = (url: string) => {
  const regex = /cloudinary:\/\/(\d+):([^@]+)@(.+)/;
  const match = url.match(regex);
  if (!match) {
    throw new Error('Invalid Cloudinary URL format');
  }
  return {
    apiKey: match[1],
    apiSecret: match[2],
    cloudName: match[3],
  };
};

export const getCloudinaryConfig = () => {
  const cloudinaryUrl = import.meta.env.VITE_CLOUDINARY_URL;
  
  if (!cloudinaryUrl) {
    // Fallback to individual environment variables if URL is not available
    const cloudName = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME;
    const apiKey = import.meta.env.VITE_CLOUDINARY_API_KEY;
    const apiSecret = import.meta.env.VITE_CLOUDINARY_API_SECRET;

    if (!cloudName || !apiKey || !apiSecret) {
      throw new Error('Cloudinary configuration is not set');
    }

    return {
      cloudName,
      apiKey,
      apiSecret,
    };
  }

  try {
    const { apiKey, apiSecret, cloudName } = parseCloudinaryUrl(cloudinaryUrl);
    
    if (!apiKey || !apiSecret || !cloudName) {
      throw new Error('Invalid Cloudinary configuration');
    }

    return {
      cloudName,
      apiKey,
      apiSecret,
    };
  } catch (error) {
    console.error('Error parsing Cloudinary configuration:', error);
    throw new Error('Failed to initialize Cloudinary configuration');
  }
}; 